export default __webpack_public_path__ + "static/media/chime6.50858f6c.mp3";